import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcNeutral = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.0002,
			cy: 10.0002,
			r: 7.85714,
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.42871 11.4284C6.42871 11.2312 6.58861 11.0713 6.78585 11.0713V11.4284V11.7856C6.58861 11.7856 6.42871 11.6257 6.42871 11.4284ZM6.78585 11.4284V11.7856H13.2142C13.4115 11.7856 13.5716 11.6257 13.5716 11.4284C13.5716 11.2312 13.4117 11.0713 13.2144 11.0713H6.78585V11.4284Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.85735,
			cy: 8.57122,
			r: .714286,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.143,
			cy: 8.57122,
			r: .714286,
			fill: "white"
		})
	]
});
export default SvgIcNeutral;
